import React, { useState } from 'react';
import { BsTwitter, BsLinkedin, BsLink45Deg, BsCheck2 } from 'react-icons/bs';

function ShareButtons({ article }) {
  const [copied, setCopied] = useState(false);
  
  const url = window.location.href;
  const title = article?.title || '';
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="share-buttons">
      <h3 className="share-heading">Share this article</h3>
      <div className="share-buttons-container">
        <a
          href={shareLinks.twitter}
          target="_blank"
          rel="noopener noreferrer"
          className="share-button share-twitter"
          aria-label="Share on Twitter"
        >
          <BsTwitter size={20} />
          <span>Twitter</span>
        </a>
        
        <a
          href={shareLinks.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="share-button share-linkedin"
          aria-label="Share on LinkedIn"
        >
          <BsLinkedin size={20} />
          <span>LinkedIn</span>
        </a>
        
        <button
          onClick={copyToClipboard}
          className="share-button share-copy"
          aria-label="Copy link"
        >
          {copied ? <BsCheck2 size={20} /> : <BsLink45Deg size={20} />}
          <span>{copied ? 'Copied!' : 'Copy Link'}</span>
        </button>
      </div>
    </div>
  );
}

export default ShareButtons;